/**
 * card-model.js
 *
 * 概述:
 * 在线题卡，手阅题卡相关API
 *
 * API:
 * 1.查询地域信息   queryAreaInfo
 * @author changh 2019/7/18
 */
import axios from 'axios'
import setConfig from '@/config/axios-config'
setConfig(axios)

const basePath = '/scantron'
const itemPath = '/ItemService'
const itemPathOld = '/ItemServer'
// const itemPathOld = '/ItemService'//20240710黄骏泳修改(开发阶段需要)
const itemBankService = '/ItemBankService'

const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}
// 查询题卡信息
export const queryCardList = (data) => {
  let urlParam = `${basePath}/Card.queryCardList?time=1563501622754`
  return axios.post(urlParam, data).then(res => res.data)
}

/**
 * 删除题卡
 * @author changh 2018-12-05T09:56:37+0800
 * @param  {
                        userId:userId,
                        cardId:cardId
                    }
 * @return {[type]}        [description]
 */
export const deleteCard = (data) => {
  let urlParam = `${basePath}/Card.delete`
  return axios.post(urlParam, data).then(res => res.data)
}

/**
 * 查询单个题卡详情
 * @author changh 2018-12-05T09:56:37+0800
 * @param  {cardId:cardId}
 * @return {[type]}        [description]
 */
export const queryCardInfo = (data) => {
  let urlParam = `${basePath}/Card.cardInfo`
  return axios.post(urlParam, data).then(res => res.data)
}

/**
 * 另存题卡
 * @author changh 2018-12-05T09:56:37+0800
 * @param  cardInfo
 * @return {[type]}        [description]
 */
export const saveCard = (data) => {
  let urlParam = `${basePath}/Card.save`
  return axios.post(urlParam, data).then(res => res.data)
}

// 设置在线题卡的使用_手阅
export const selectCardForExam = (data) => {
  let urlParam = `${itemPath}/selectCardForExam?time=1563501622754`
  return axios.post(urlParam, data).then(res => res.data)
}

// 设置在线题卡的使用_普通在线题卡
export const selectCardForExamOld = (data) => {
  let param = 'flag=selectCardForExam&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${itemPathOld}/item.jsp`, param, axiosConfig)
    .then(res => res.data)
}

// 查询考试使用的在线题卡ID 0:纸质卡,1,在线题卡，2，手阅卡
export const queryCardForExam = (data) => {
  let param = 'flag=queryCardForExam&json=' + JSON.stringify(data) + '&time=' + Math.random()
  return axios.post(`${itemPathOld}/item.jsp`, param, axiosConfig)
    .then(res => res.data)
}

/**
 * 根据试卷id生成在线题卡
 * @author changh 2020-03-12T09:56:37+0800
 * @param  {Object}  {
    "data":{
        "paperId":0,//试卷id-必填
        "userId":"123456",//用户id-必填
    }
  } [description]
 * @return {[type]}        [description]
 */
export const syncOnlineCard = (data) => {
  let urlParam = `${itemBankService}/syncOnlineCard`
  return axios.post(urlParam, data).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/model/card-model.js